import { observer } from 'mobx-react';
import * as React from 'react';
import { Address, Room } from '../../../stores/AddressStore';
import { Segment } from '../../../stores/SegmentStore';
import { ProductCard } from '../InternetCalculatorInterfaces';
import ExceptionCard from './ExceptionCard';
import InternetCard from './InternetCard';
import PlannedCard from './PlannedCard';
import SpecialRequestCard from './SpecialRequestCard';

interface Props {
  calculatorKey: string;
  card: ProductCard;
  segment: Segment;
  isRecommended: boolean;
  partner: boolean;
  hideBetterInternetForms: boolean;
  selectedAddress: Address;
  specialRequestFormName?: string;
  selectedRoom?: Room;
  noEmptySpaceOnTop: boolean;
}

const CalculatorCard = (props: Props): JSX.Element => {
  const { partner, segment, calculatorKey, card, selectedAddress, selectedRoom, hideBetterInternetForms, specialRequestFormName } = props;
  if (card.productOfferingCode === 'EXCEPTION_FIX4G') {
    return <ExceptionCard {...{ selectedAddress, selectedRoom }} key={card.uid} />;
  }

  if (card.plannedNetwork) {
    return (
      <PlannedCard
        segment={segment}
        card={card}
        partner={partner}
        hideBetterInternetForms={hideBetterInternetForms}
        key={card.uid}
        noEmptySpaceOnTop={props.noEmptySpaceOnTop}
      />
    );
  }

  if (card.specialRequest) {
    return (
      <SpecialRequestCard
        specialRequestFormName={specialRequestFormName}
        calculatorKey={calculatorKey}
        key={card.uid}
        noEmptySpaceOnTop={props.noEmptySpaceOnTop}
      />
    );
  }
  return (
    <InternetCard
      key={card.uid}
      calculatorKey={calculatorKey}
      segment={props.segment}
      isRecommended={props.isRecommended}
      card={card}
      noEmptySpaceOnTop={props.noEmptySpaceOnTop}
    />
  );
};

export default observer(CalculatorCard);
